import React from "react";

function FilterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M22.875 18.625c.61 0 1.125.516 1.125 1.125a1.11 1.11 0 01-1.125 1.125h-11.11A3.67 3.67 0 018.25 23.5a3.685 3.685 0 01-3.563-2.625H1.126C.469 20.875 0 20.406 0 19.75c0-.61.469-1.125 1.125-1.125h3.563A3.742 3.742 0 018.25 16c1.64 0 3.047 1.125 3.516 2.625h11.109zM8.25 21.25c.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5zm14.625-10.125c.61 0 1.125.516 1.125 1.125a1.11 1.11 0 01-1.125 1.125h-3.61A3.67 3.67 0 0115.75 16a3.685 3.685 0 01-3.563-2.625H1.126C.469 13.375 0 12.906 0 12.25c0-.61.469-1.125 1.125-1.125h11.063A3.742 3.742 0 0115.75 8.5c1.64 0 3.047 1.125 3.516 2.625h3.609zM15.75 13.75c.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5zM1.125 5.875C.469 5.875 0 5.406 0 4.75c0-.61.469-1.125 1.125-1.125h5.063A3.742 3.742 0 019.75 1c1.64 0 3.047 1.125 3.516 2.625h9.609c.61 0 1.125.516 1.125 1.125a1.11 1.11 0 01-1.125 1.125h-9.61A3.67 3.67 0 019.75 8.5a3.685 3.685 0 01-3.563-2.625H1.125zM9.75 3.25c-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5z"
      ></path>
    </svg>
  );
}

export default React.memo(FilterIcon);
